import quijoteluiService from './quijotelui'

const trackService = {}

// Facturas

trackService.buscaFactura = function (fechaInicio, fechaFin, estado) {
  // console.log(quijoteluiService)
  const fechaReporte = `/reporte_factura_estado/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}/estado/${estado}`
  return quijoteluiService.get(fechaReporte)
    .then(res => {
      console.log(`Url Base: ${quijoteluiService._baseUrl}`)
      return res.data
    })
}

trackService.autorizaFactura = function (fechaInicio, fechaFin) {
  const fechasAutorizar = `/factura_autoriza/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}`
  return quijoteluiService.get(fechasAutorizar)
    .then(res => {
      return res.data
    }).catch(e => {
      if (e.status === 401) {
        console.log(`401 Unauthorized`)
        return `Unauthorized`
      } else {
        console.log(e.status)
      }
    })
}

trackService.autorizaUnaFactura = function (codigo, numero) {
  const autorizaUna = `/factura_procesar/codigo/${codigo}/numero/${numero}`
  return quijoteluiService.get(autorizaUna)
    .then(res => {
      console.log(`Url Base: ${quijoteluiService._baseUrl}`)
      return res.data
    })
}

trackService.verificaFactura = function (fechaInicio, fechaFin) {
  const fechasVerificar = `/factura_verifica/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}`
  return quijoteluiService.get(fechasVerificar)
    .then(res => {
      return res.data
    })
}

// Retención

trackService.buscaRetencion = function (fechaInicio, fechaFin, estado) {
  const fechaReporte = `/reporte_retencion_estado/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}/estado/${estado}`
  return quijoteluiService.get(fechaReporte)
    .then(res => {
      console.log(`Url Base: ${quijoteluiService._baseUrl}`)
      return res.data
    })
}

trackService.autorizaRetencion = function (fechaInicio, fechaFin) {
  const fechasAutorizar = `/retencion_autoriza/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}`
  return quijoteluiService.get(fechasAutorizar)
    .then(res => {
      return res.data
    })
}

trackService.autorizaUnaRetencion = function (codigo, numero) {
  const autorizaUna = `/retencion_procesar/codigo/${codigo}/numero/${numero}`
  return quijoteluiService.get(autorizaUna)
    .then(res => {
      return res.data
    })
}

trackService.verificaRetencion = function (fechaInicio, fechaFin) {
  const fechasVerificar = `/retencion_verifica/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}`
  return quijoteluiService.get(fechasVerificar)
    .then(res => {
      return res.data
    })
}

// Nota de Crédito

trackService.buscaNotaCredito = function (fechaInicio, fechaFin, estado) {
  const fechaReporte = `/reporte_nota_credito_estado/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}/estado/${estado}`
  return quijoteluiService.get(fechaReporte)
    .then(res => {
      console.log(`Url Base: ${quijoteluiService._baseUrl}`)
      return res.data
    })
}

trackService.autorizaNotaCredito = function (fechaInicio, fechaFin) {
  const fechasAutorizar = `/nota_credito_autoriza/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}`
  return quijoteluiService.get(fechasAutorizar)
    .then(res => {
      return res.data
    })
}

trackService.autorizaUnaNotaCredito = function (codigo, numero) {
  const autorizaUna = `/nota_credito_procesar/codigo/${codigo}/numero/${numero}`
  return quijoteluiService.get(autorizaUna)
    .then(res => {
      return res.data
    })
}

trackService.verificaNotaCredito = function (fechaInicio, fechaFin) {
  const fechasVerificar = `/nota_credito_verifica/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}`
  return quijoteluiService.get(fechasVerificar)
    .then(res => {
      return res.data
    })
}

// Nota de Débito

trackService.buscaNotaDebito = function (fechaInicio, fechaFin, estado) {
  const fechaReporte = `/reporte_nota_debito_estado/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}/estado/${estado}`
  return quijoteluiService.get(fechaReporte)
    .then(res => {
      console.log(`Url Base: ${quijoteluiService._baseUrl}`)
      return res.data
    })
}

trackService.autorizaNotaDebito = function (fechaInicio, fechaFin) {
  const fechasAutorizar = `/nota_debito_autoriza/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}`
  return quijoteluiService.get(fechasAutorizar)
    .then(res => {
      return res.data
    })
}

trackService.autorizaUnaNotaDebito = function (codigo, numero) {
  const autorizaUna = `/nota_debito_procesar/codigo/${codigo}/numero/${numero}`
  return quijoteluiService.get(autorizaUna)
    .then(res => {
      return res.data
    })
}

trackService.verificaNotaDebito = function (fechaInicio, fechaFin) {
  const fechasVerificar = `/nota_debito_verifica/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}`
  return quijoteluiService.get(fechasVerificar)
    .then(res => {
      return res.data
    })
}

// Liquidación en Compras

trackService.buscaLiquidacion = function (fechaInicio, fechaFin, estado) {
  const fechaReporte = `/reporte_liquidacion_estado/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}/estado/${estado}`
  return quijoteluiService.get(fechaReporte)
    .then(res => {
      console.log(`Url Base: ${quijoteluiService._baseUrl}`)
      return res.data
    })
}

trackService.autorizaLiquidacion = function (fechaInicio, fechaFin) {
  const fechasAutorizar = `/liquidacion_autoriza/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}`
  return quijoteluiService.get(fechasAutorizar)
    .then(res => {
      return res.data
    })
}

trackService.autorizaUnaLiquidacion = function (codigo, numero) {
  const autorizaUna = `/liquidacion_procesar/codigo/${codigo}/numero/${numero}`
  return quijoteluiService.get(autorizaUna)
    .then(res => {
      return res.data
    }).catch(function (error) {
      console.error(error.stack)
    })
}

trackService.verificaLiquidacion = function (fechaInicio, fechaFin) {
  const fechasVerificar = `/liquidacion_verifica/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}`
  return quijoteluiService.get(fechasVerificar)
    .then(res => {
      return res.data
    })
}

// Guía de Remisión

trackService.buscaGuia = function (fechaInicio, fechaFin, estado) {
  const fechaReporte = `/reporte_guia_estado/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}/estado/${estado}`
  return quijoteluiService.get(fechaReporte)
    .then(res => {
      console.log(`Url Base: ${quijoteluiService._baseUrl}`)
      return res.data
    })
}

trackService.autorizaGuia = function (fechaInicio, fechaFin) {
  const fechasAutorizar = `/guia_autoriza/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}`
  return quijoteluiService.get(fechasAutorizar)
    .then(res => {
      return res.data
    })
}

trackService.autorizaUnaGuia = function (codigo, numero) {
  const autorizaUna = `/guia_procesar/codigo/${codigo}/numero/${numero}`
  return quijoteluiService.get(autorizaUna)
    .then(res => {
      return res.data
    })
}

trackService.verificaGuia = function (fechaInicio, fechaFin) {
  const fechasVerificar = `/guia_verifica/fechaInicio/${fechaInicio}/fechaFin/${fechaFin}`
  return quijoteluiService.get(fechasVerificar)
    .then(res => {
      return res.data
    })
}

trackService.pdf = function () {
  const comprobante = `/pdf/`
  return `${quijoteluiService._baseUrl}${comprobante}`
}

trackService.xml = function () {
  const comprobante = `/xml/`
  return `${quijoteluiService._baseUrl}${comprobante}`
}

trackService.electronicoById = function (codigo, numero) {
  const comprobante = `/electronico/codigo/${codigo}/numero/${numero}`
  return quijoteluiService.get(comprobante)
    .then(res => {
      return res.data
    })
}

trackService.pendiente = function () {
  return quijoteluiService.get(`/pendientes`)
    .then(res => res.data)
}

trackService.contarPendiente = function () {
  return quijoteluiService.get(`/contar_pendientes`)
    .then(res => res.data)
}

trackService.borrarPendiente = function (id) {
  console.log(`Borrar ${id}`)
  return quijoteluiService.delete(`/pendientes/${id}`)
    .then(res => {
      return res.data
    }).catch(function (error) {
      console.error(error.stack)
    })
}

trackService.contribuyente = function () {
  return quijoteluiService.get(`/contribuyente`)
    .then(res => res.data)
}

trackService.suscripcion = function () {
  return quijoteluiService.get(`/suscripcion`)
    .then(res => res.data)
}

trackService.suscripcionActualizar = function () {
  return quijoteluiService.put(`/suscripcion/actualizar`)
    .then(res => res.data)
}

trackService.enviarCorreo = function (codigo, numero) {
  const enviar = `/enviar_correo/codigo/${codigo}/numero/${numero}`
  return quijoteluiService.get(enviar)
    .then(res => {
      return res
    }).catch(function (error) {
      console.error(error.stack)
    })
}

export default trackService
